import React from 'react';
import { Phone, Clock, ShieldCheck } from 'lucide-react';
import { SiteData } from '../types/data';
import defaultHeroBg from '../assets/hero-bg.jpg';

interface HeroProps {
  data: SiteData['hero'];
  phone: string;
}

export const Hero = ({ data, phone }: HeroProps) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={data.heroImage || defaultHeroBg} 
          alt="Zámečník pozadí" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/40"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-white">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-primary/20 border border-primary/30 rounded-full px-4 py-1 mb-6 backdrop-blur-sm">
            <Clock className="w-4 h-4 text-primary" />
            <span className="text-white text-sm font-medium">{data.badge}</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            {data.title} <br />
            <span className="text-primary">{data.subtitle}</span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl leading-relaxed">
            {data.description}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href={`tel:${phone.replace(/\s/g, '')}`} 
              className="flex items-center justify-center gap-3 bg-primary hover:bg-primary-hover text-white px-8 py-4 rounded-xl font-bold text-lg transition-all hover:shadow-lg hover:shadow-primary/30 transform hover:-translate-y-1"
            >
              <Phone className="w-6 h-6" />
              {data.ctaPrimary}
            </a>
            <button 
              onClick={() => document.getElementById('sluzby')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 px-8 py-4 rounded-xl font-bold text-lg transition-all backdrop-blur-sm"
            >
              <ShieldCheck className="w-6 h-6" />
              {data.ctaSecondary}
            </button>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-6 border-t border-white/10 pt-8">
            {data.stats.map((stat, index) => (
              <div key={index}>
                <p className="text-3xl font-bold text-primary">{stat.value}</p>
                <p className="text-gray-400 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
